import React, { useState } from "react";
import axios from "axios";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    service: "",
    comments: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  setLoading(true);

  try {
    const response = await fetch(
      "https://script.google.com/macros/s/AKfycbzarPrFP5bxRAWt9bKseenOljffX_QqWoS0IR39yVnlgy6_gNSdfLGWtYHnPwKR_td3gw/exec", 
      {
        method: "POST",
        body: JSON.stringify(formData)
      }
    );

    console.log(response)

    if (response.status === 200) {
      setSuccessMessage("We’ve received your request successfully. Our team will be in touch with you shortly.");
      setFormData({
        name: "",
        email: "",
        phone: "",
        company: "",
        service: "",
        comments: "",
      });
    } else {
      setErrorMessage("Something went wrong!");
    }

  } catch (error) {
    console.error("Email Error:", error);
    setErrorMessage("Failed to send email!");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className=" mb-5">
      <section className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8  p-8 rounded-lg">
        <div className="flex justify-center items-center">
          <div className="relative">
            <img
              src="/assets/images/contactus.avif"
              alt="Assistant"
              className="rounded-lg"
            />
            <div className="absolute bottom-4 left-4 bg-green-700 text-white py-2 px-4 rounded-full shadow-xl">
              Got a vision? We make it happen!
            </div>
          </div>
        </div>
        <div
          className="p-4 rounded-lg shadow-xl bg-white mt-10 md:mt-10 lg:mt-20 "
          style={{
            boxShadow:
              "0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08), 0 0 15px 4px rgba(59, 130, 246, 0.4), 0 0 15px 4px rgba(16, 185, 129, 0.4)",
          }}
        >
          <h2 className="text-2xl font-bold mb-6">
            Let’s connect & create something amazing!
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Mobile Number"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <input
              type="text"
              name="company"
              placeholder="Company Name"
              value={formData.company}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <input
              type="text"
              name="service"
              placeholder="Service Required"
              value={formData.service}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
            <textarea
              name="comments"
              placeholder="Any Comments"
              value={formData.comments}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
            ></textarea>
            <button
              type="submit"
              disabled={loading}
              className="bg-green-600 text-white py-2 px-6 rounded-full hover:bg-yellow-400 hover:text-black transition duration-300"
            >
              {loading ? "Sending..." : "Send"}
            </button>
          </form>
          {successMessage && (
            <p className="text-green-500 mt-4">{successMessage}</p>
          )}
          {errorMessage && <p className="text-red-500 mt-4">{errorMessage}</p>}
        </div>
      </section>

      <section className="max-w-7xl mx-auto mt-16">
        <div className="bg-blue-800 text-white py-8 px-4 rounded-2xl mt-10">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
              Ayanshtech's Commitment
            </h2>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl">
              At Ayanshtech, we are committed to exceeding your expectations.
              Our team of experts will work closely with you to ensure a
              successful project outcome.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
